module.exports = __webpack_public_path__ + "img/calendar.e82517b2.svg";